/**
 * Toolbar glyphs from Figma `421:37450`. Each file keeps the exported root
 * width and height (19, 22.8, or 24). Do not scale them.
 */
import type { ComponentType, ReactNode, SVGProps } from 'react';

import ArrowIcon from './icons/arrow.svg?react';
import BrushIcon from './icons/brush.svg?react';
import CancelIcon from './icons/cancel.svg?react';
import CopyIcon from './icons/copy.svg?react';
import DividerIcon from './icons/divider.svg?react';
import DownloadIcon from './icons/download.svg?react';
import MosaicIcon from './icons/mosaic.svg?react';
import OkIcon from './icons/ok.svg?react';
import RedoIcon from './icons/redo.svg?react';
import TextIcon from './icons/text.svg?react';
import UndoIcon from './icons/undo.svg?react';

type Glyph = ComponentType<SVGProps<SVGSVGElement>>;

function GlyphSlot({ icon: Icon }: { icon: Glyph }): ReactNode {
  return (
    <span aria-hidden="true" className="inline-flex">
      <Icon />
    </span>
  );
}

export function ArrowGlyph(): ReactNode {
  return <GlyphSlot icon={ArrowIcon} />;
}

export function BrushGlyph(): ReactNode {
  return <GlyphSlot icon={BrushIcon} />;
}

export function TextGlyph(): ReactNode {
  return <GlyphSlot icon={TextIcon} />;
}

export function MosaicGlyph(): ReactNode {
  return <GlyphSlot icon={MosaicIcon} />;
}

export function UndoGlyph(): ReactNode {
  return <GlyphSlot icon={UndoIcon} />;
}

export function RedoGlyph(): ReactNode {
  return <GlyphSlot icon={RedoIcon} />;
}

export function CopyGlyph(): ReactNode {
  return <GlyphSlot icon={CopyIcon} />;
}

export function DownloadGlyph(): ReactNode {
  return <GlyphSlot icon={DownloadIcon} />;
}

export function CancelGlyph(): ReactNode {
  return <GlyphSlot icon={CancelIcon} />;
}

export function OkGlyph(): ReactNode {
  return <GlyphSlot icon={OkIcon} />;
}

/** Horizontal 16×1 rule, rotated to the vertical divider in `421:37480`. */
export function ToolDivider(): ReactNode {
  return (
    <span className="flex h-[var(--app-base-size-9)] w-0 shrink-0 items-center justify-center">
      <span className="rotate-90">
        <span aria-hidden="true" className="inline-flex">
          <DividerIcon />
        </span>
      </span>
    </span>
  );
}
